var _a;
import { __assign, __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import get from "lodash/get";
import omit from "lodash/omit";
import upperCase from "lodash/upperCase";
import FolderIcon from "@mui/icons-material/Folder";
import LockIcon from "@mui/icons-material/Lock";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Badge, Box, Tooltip, Typography, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
export var MimeType;
(function (MimeType) {
    MimeType["Pdf"] = "pdf";
    MimeType["Png"] = "png";
    MimeType["Jpeg"] = "jpeg";
    MimeType["Jpg"] = "jpg";
    MimeType["Txt"] = "txt";
    MimeType["Docx"] = "docx";
})(MimeType || (MimeType = {}));
export var MimeTypeColor = (_a = {},
    _a[MimeType.Pdf] = "#F23140",
    _a[MimeType.Png] = "#469FF8",
    _a[MimeType.Jpeg] = "#469FF8",
    _a[MimeType.Jpg] = "#469FF8",
    _a[MimeType.Txt] = "#3A8D11",
    _a[MimeType.Docx] = "#3A8D11",
    _a);
var _PasswordBadge = function (props) {
    var theme = useTheme();
    return (_jsx("span", __assign({}, omit(props, ["ownerState"]), { style: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            position: "absolute",
            minWidth: "8px",
            lineHeight: 1,
            padding: 0,
            height: "16px",
            borderRadius: "8px",
            zIndex: 1,
            transition: "transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            backgroundColor: theme.palette.background.paper,
            bottom: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
        }, children: _jsx(LockIcon, { style: { fontSize: "0.8rem" } }) })));
};
var PasswordBadge = function (_a) {
    var children = _a.children, password = _a.password;
    if (!password) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(Tooltip, { title: "Password protected file", children: _jsx(Badge, { variant: "dot", overlap: "circular", anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, sx: {
                ".MuiBadge-badge": {
                    border: "1px solid transparent",
                },
            }, color: "info", badgeContent: _jsx(LockIcon, {}), slots: {
                badge: _PasswordBadge,
            }, children: children }) }));
};
var StoreObjectIcon = function (_a) {
    var type = _a.type, mimeType = _a.mimeType, password = _a.password, props = __rest(_a, ["type", "mimeType", "password"]);
    if (type === "folder") {
        return (_jsx(PasswordBadge, { password: password, children: _jsx(FolderIcon, __assign({}, props)) }));
    }
    var color = get(MimeTypeColor, mimeType, "inherit");
    if (mimeType.length <= 4) {
        return (_jsx(PasswordBadge, { password: password, children: _jsxs(Box, { sx: {
                    width: "fit-content",
                    position: "relative",
                    height: "24px",
                }, children: [_jsx(InsertDriveFileIcon, __assign({ style: { fill: color } }, props)), _jsx(Typography, { sx: {
                            position: "absolute",
                            bottom: "6px",
                            left: "5px",
                            fontSize: "7px",
                            color: "#fff",
                            height: "17px",
                            lineHeight: "1.5rem",
                        }, children: upperCase(mimeType) })] }) }));
    }
    return (_jsx(PasswordBadge, { password: password, children: _jsx(InsertDriveFileIcon, __assign({ style: { fill: color } }, props)) }));
};
export default StoreObjectIcon;
